module.exports = __webpack_public_path__ + "static/media/swiss-croatian-collaboration.315f8449.png";